module.exports = __webpack_public_path__ + "img/store.efde5f7.svg";